<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                      <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">

            <div class="mat-toolbar-custom">
                <mat-toolbar>
                    <mat-toolbar-row>


                        <button mat-flat-button color="accent" (click)="cReporteExcel()"
                             [disabled]="loadingReporte">
                            <mat-icon *ngIf="!loadingReporte">download</mat-icon>
                            {{botonReporte}}
                        </button>

                        <span class="mat-toolbar-row-separador"></span>


                    </mat-toolbar-row>

                </mat-toolbar>

            </div>






        </div>
    </div>
</div>
<div class="container-custom-content">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" #input>
                </mat-form-field>
                <div class="mat-table-productos">
                    <table mat-table matTableResponsive [dataSource]="dataSource" matSort matSortActive="nombre"
                        matSortDirection="asc">

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Acciones}} </th>
                            <td mat-cell *matCellDef="let c">
                                <div>

                                    <button matTooltip="{{Tooltips.Editar}}" (click)="dialogCuenta(2,c)" mat-icon-button
                                        color="primary-darker">
                                        <mat-icon color="accent-darker">edit</mat-icon>
                                    </button>



                                </div>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nroCliente">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.NroCliente}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.nroCliente}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nombre">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.Nombre}}
                            </th>
                            <td mat-cell *matCellDef="let c">
                                {{c.nombre}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{Etiquetas.Headers.Status}}
                            </th>
                            <td mat-cell *matCellDef="let c" class="status_cuenta" [matTooltip]="
                            c.mensajeStatus.length
                              ? c.mensajeStatus
                              : ''"
                                [ngClass]="c.status != null && (c.status.length) ? 'status_cuenta_color_'+c.status : ''">
                                {{c.status}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="bloqueo">
                            <th mat-header-cell *matHeaderCellDef>
                                {{Etiquetas.Headers.Bloqueo}}
                            </th>
                            <td style="cursor: default;" [matTooltip]="
                            c.mensajeBloqueo != null
                              ? c.mensajeBloqueo
                              : 'Cuenta habilitada'" mat-cell *matCellDef="let c">
                                <mat-icon *ngIf="c.mensajeBloqueo != null" color="warn">
                                    lock</mat-icon>
                                <mat-icon *ngIf="c.mensajeBloqueo == null" color="primary">
                                    lock_open_right</mat-icon>
                            </td>
                        </ng-container>



                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let c; columns: displayedColumns;">
                        </tr>


                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumns.length">{{Etiquetas.SinRegistros}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>

</div>